import { FC } from "react";
import { Box, Container, Grid, Heading, Text, VStack } from "@chakra-ui/react";
import { LandingPageContent } from "@/constants/landingPages";

interface LandingFeaturesSectionProps {
  content: LandingPageContent["features"];
}

export const LandingFeaturesSection: FC<LandingFeaturesSectionProps> = ({ content }) => (
  <Box py={{ base: "16", md: "24" }} bg="white">
    <Container maxW="7xl">
      <VStack spacing="12">
        {/* Section header */}
        <Heading as="h2" fontSize={{ base: "3xl", md: "4xl" }} color="gray.900" textAlign="center">
          {content.title}
        </Heading>

        {/* Features grid */}
        <Grid
          templateColumns={{
            base: "1fr",
            md: "repeat(2, 1fr)",
            lg: "repeat(4, 1fr)",
          }}
          gap="6"
          w="100%"
        >
          {content.items.map((feature) => (
            <Box
              key={feature.id}
              bg="gray.50"
              borderRadius="lg"
              p="6"
              textAlign="center"
              transition="all 0.3s"
              _hover={{
                bg: "blue.50",
                transform: "translateY(-2px)",
              }}
            >
              <VStack spacing="3">
                <Box fontSize="3xl">{feature.icon}</Box>
                <Text fontSize="md" fontWeight="bold" color="gray.900">
                  {feature.title}
                </Text>
                <Text fontSize="sm" color="gray.600" lineHeight="1.6">
                  {feature.description}
                </Text>
              </VStack>
            </Box>
          ))}
        </Grid>
      </VStack>
    </Container>
  </Box>
);
